import { appendIf } from '@btime/helpers'
import React from 'react'

import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../../../packages/kiti/components/form/Select'
import { useShouldHideBondSelect } from '../../_helpers/shouldHideField'

const BondSelect = ({ index, ...props }) => {
  const payload_path = index >= 0 ? ['payload', index] : ['payload']
  const path = [...payload_path, 'bond']
  const { handleChangeIn, form } = useFormState()

  const shouldHideBondSelect = useShouldHideBondSelect()

  const isFromNonComplianceEvent = ['non_compliance_event'].includes(form.entity)
  const isFromNonCompliance = ['non_compliance'].includes(form.entity)
  // service_order_tag_assigned/removed despacham o mesmo registro achatado que service_order/event,
  // então valem as mesmas opções de vínculo ("filha da atividade da automação"/"filha da atividade pai").
  const isFromServiceOrder = [
    'event',
    'service_order',
    'service_order_tag_assigned',
    'service_order_tag_removed'
  ].includes(form.entity)
  const isFromFormReply = ['form_reply'].includes(form.entity)
  // O registro dessas duas entidades de tag é exposto na interpolação do backend com a mesma raiz
  // "service_order" usada pela entidade `service_order` (não há uma raiz própria "service_order_tag_assigned"
  // nem aninhamento como em `event`), então o prefixo da chave deve ficar vazio igual ao caso `service_order`.
  const isServiceOrderShaped = ['service_order', 'service_order_tag_assigned', 'service_order_tag_removed'].includes(
    form.entity
  )
  if (shouldHideBondSelect()) return false

  const options = [
    { id: 'no_bond', name: 'Sem vínculo' },
    ...appendIf(isFromNonComplianceEvent || isFromServiceOrder, {
      id: 'child',
      name: 'Filha da atividade da automação'
    }),
    ...appendIf(isFromNonComplianceEvent || isFromServiceOrder, {
      id: 'grandchild',
      name: 'Filha da atividade pai da automação'
    }),
    ...appendIf(isFromNonCompliance || isFromNonComplianceEvent, {
      id: 'non_compliance',
      name: 'Vinculada a não conformidade'
    }),
    ...appendIf(isFromFormReply, {
      id: 'form_reply',
      name: 'Vinculada a resposta do formulário'
    })
  ]

  const handleChange = value => {
    handleChangeIn([...payload_path, 'bond'], value)
    handleChangeIn([...payload_path, 'parent_id'], null)
    handleChangeIn([...payload_path, 'non_compliance_id'], null)
    handleChangeIn([...payload_path, 'form_reply_id'], null)
    handleChangeIn([...payload_path, 'type'], undefined)

    switch (value?.id) {
      case 'child':
        var key = `::{{${isServiceOrderShaped ? '' : form.entity + '.'}service_order.id}}`
        handleChangeIn([...payload_path, 'parent_id'], key)
        break

      case 'grandchild':
        var key = `::{{${isServiceOrderShaped ? '' : form.entity + '.'}service_order.parent_id}}`
        handleChangeIn([...payload_path, 'parent_id'], key)
        break

      case 'non_compliance':
        var key = `::{{${form.entity === 'non_compliance' ? '' : form.entity + '.'}non_compliance.id}}`
        handleChangeIn([...payload_path, 'non_compliance_id'], key)
        break

      case 'form_reply':
        var key = `::{{form_reply.id}}`
        handleChangeIn([...payload_path, 'form_reply_id'], key)
        break

      default:
    }
  }

  return <FormItem label="Vínculo" path={path} Input={Select} options={options} {...props} onChange={handleChange} />
}

export default BondSelect
